/**
 * @typedef {object} LineSearchResult
 * @property {string} id
 * @property {string} code
 * @property {string} title
 */

/**
 * @typedef {object} LineOption
 * @property {string} code
 * @property {string} title
 * @property {string} key Original GraphQL id, used for React key + downstream filter payload.
 */

/**
 * Map the raw `searchLinesByCode` response into autocomplete-friendly options.
 *
 * @param {LineSearchResult[] | null | undefined} lines
 * @returns {LineOption[]}
 */
export const mapLinesToOptions = (lines) => {
	if (!lines) return [];
	return lines.map((line) => ({
		code: line.code,
		title: line.title,
		key: line.id,
	}));
};
